import React from "react";
import { Table, Spin, Popconfirm } from "antd";
import moment from "moment";

const SpareAdjustmentTable = ({ data, pagination, loading, onRowClick, deleteData, deleteAccess }) => {
  const columns = [
    {
      title: "Part",
      key: "partNumber",
      render: (part) => part?.partNo?.partNumber + "-" + part?.partNo?.partName
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branchName",
      render: (branch) => branch?.name || "-",
    },
    {
      title: "Old Quantity",
      dataIndex: "availableQuantity",
      key: "availableQuantity",
    },
    {
      title: "New Quantity",
      dataIndex: "newQuantity",
      key: "newQuantity",
    },
    {
      title: "Adjusted",
      key: "adjusted",
      render: (record) => {
        const adjusted = (record.newQuantity || 0) - (record.availableQuantity || 0);
        const color = adjusted >= 0 ? "green" : "red";
        return <span style={{ color }}>{adjusted > 0 ? `+${adjusted}` : adjusted}</span>;
      },
    },
    {
      title: "Adjusted By",
      dataIndex: "adjustByUser",
      key: "adjustByUser",
      render: (user) => user?.profile?.employeeName || "-",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => moment(text).format("DD-MM-YYYY"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <div>
          {deleteAccess && (
            <Popconfirm 
              title="Are you sure you want to delete this record?"
              onConfirm={() => deleteData(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <span
                className="linkylink"
                style={{ color: "red" }}
                onClick={(e) => e.stopPropagation()}
              >
                Delete
              </span>
            </Popconfirm>
          )}
        </div>
      ),
    }
  ];

  return (
    <Spin spinning={loading}>
      <Table
        dataSource={data}
        columns={columns}
        pagination={pagination}
        rowKey="id"
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        style={{ cursor: "pointer" }}
      />
    </Spin>
  );
};

export default SpareAdjustmentTable;
